<!-- Source and saved video dialogs: the videos of the plan that link this item among their references (video.sourceIds /
     savedIds, src/features/videoRefs.ts), each opening its video (the dialog closes first), except while a video dialog
     is open under it (it would replace the video being edited): then they are plain labels. Nothing when no video uses it. -->
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '../../composables/useI18n'
import { useProfileData } from '../../composables/useProfileData'
import { useVideoStore } from '../../stores/video'
import { useDialogsStore } from '../../stores/dialogs'
import { refUsage, type RefGroup } from '../../features/videoRefs'

const props = defineProps<{ group: RefGroup; id: string | null }>()
const emit = defineEmits<{ open: [] }>()
const { t } = useI18n()
const data = useProfileData()
const videos = computed(() => (props.id ? refUsage(data.value, props.group, props.id) : []))
const canOpen = computed(() => !useDialogsStore().isOpen('video'))
function open(id: string) { emit('open'); useVideoStore().open(id) }
</script>

<template>
  <div v-if="videos.length">
    <label class="block text-xs font-bold text-gray-400 mb-2 tracking-wider">{{ t('USED IN') }}</label>
    <div class="flex flex-wrap gap-1.5">
      <component :is="canOpen ? 'button' : 'span'" v-for="v in videos" :key="v.id" :type="canOpen ? 'button' : undefined"
        :class="['inline-flex items-center gap-1.5 max-w-full px-3 py-1.5 rounded-full bg-darkinput border border-gray-800 text-xs font-bold text-gray-200', { 'hover:border-brand hover:text-brand': canOpen }]" @click="canOpen && open(v.id)">
        <i class="fas fa-film text-[10px] text-gray-500"></i><span class="truncate">{{ v.title || t('Untitled') }}</span></component>
    </div>
  </div>
</template>
